import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from "./Text";
import { Block } from "./Block";
import { Link } from "./Link";
import { LineBreak } from "./LineBreak";
const getStyle = (data) => ({
    textAlign: data.format !== "" ? data.format : undefined,
    direction: data.direction === "rtl" ? data.direction : undefined
});
export const Paragraph = ({ data, options }) => {
    const style = getStyle(data);
    const children = data.children.map((paragraphChild, index) => {
        if (paragraphChild.type === "text") {
            return (_jsx(Text, { data: paragraphChild, options: options, style: style, wrapTextInSpan: data.wrapTextInSpan }, paragraphChild.text));
        }
        else if (paragraphChild.type === "link") {
            return (_jsx(Link, { data: paragraphChild, options: options, style: style }, paragraphChild.id));
        }
        else if (paragraphChild.type === "linebreak") {
            return _jsx(LineBreak, { data: paragraphChild, options: options }, index);
        }
        else {
            return _jsx(Block, { data: paragraphChild, options: options }, index);
        }
    });
    return options?.paragraph ? (options.paragraph(data, children)) : (_jsx("p", { children: children }));
};
